<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
    width="600px"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="140px" label-suffix="：">
      <el-form-item label="方案名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入方案名称" v-trim/>
      </el-form-item>
      <el-form-item label="开始时间" prop="startDate">
<!--        HH:mm:ss-->
        <el-date-picker v-model="form.startDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="请选择开始时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endDate">
<!--        HH:mm:ss-->
        <el-date-picker v-model="form.endDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="请选择结束时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="优先级（升序）" prop="sortnum">
        <el-input v-model="form.sortnum" placeholder="请输入优先级（升序）" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaPricingParamWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        name: '',
        startDate: '',
        endDate: '',
        sortnum: '',
      },
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入方案名称', tigger: 'blur' },
        ],
        startDate: [
          { required: true, message: '请选择开始时间', tigger: 'change' },
        ],
        endDate: [
          { required: true, message: '请选择结束时间', tigger: 'change' },
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/business/pricingParam',
      'field.id': 'id'
    })
  }
}
</script>
